import { useMemo } from "react";
import { useIsFeatureFlagEnabled } from "../featureFlags/useIsFeatureFlagEnabled";

/**
 * Check if a trap is cancelled (CNCL status)
 * @param status - Trap status
 * @param isFeatureFlagEnabled - Feature flag status for CNCL trap treatment
 * @returns true if the feature flag is enabled AND the trap has CNCL status
 */
export function checkIsTrapCancelled(
  status: string | null | undefined,
  isFeatureFlagEnabled: boolean
): boolean {
  return isFeatureFlagEnabled && status === "CNCL";
}

/**
 * Hook to check if a trap has CNCL status
 * Returns true for cancelled traps (when feature flag is enabled), preventing user interactions
 * @param status - Trap status
 * @returns true if the trap should be treated as cancelled (non-interactive)
 */
export function useIsTrapCancelled(status: string | null | undefined): boolean {
  const isFeatureFlagEnabled = useIsFeatureFlagEnabled(
    "operations-5594-CNCL-traps-treatment-client"
  );

  return useMemo(
    () => checkIsTrapCancelled(status, isFeatureFlagEnabled),
    [status, isFeatureFlagEnabled]
  );
}
